import React, { Component } from 'react'
import { Section } from '../../../components'
import OpeningPrice from './elements/OpeningPrice'
import BidSubmission from './elements/BidSubmission'
import ExtensionTime from './elements/ExtensionTime'
import MaxExtensionTime from './elements/MaxExtensionTime'
import DisplayDummy from './elements/DisplayDummy'

export default class AuctionEnglish extends Component {
  render() {
    const {
      auctionType,
      formData,
      isErrOpeningPrice,
      editRoleDetail,
      isErrBIDDecrement,
      isErrBIDMinimum,
      isErrBID,
      isErrExtensionMinutes,
      isErrMaxExtensionTime,
      isSetState,
    } = this.props

    return (
      <>
        <Section className="form-row">
          <Section className="form-col col-6">
            {/* opening price  */}
            <OpeningPrice
              auctionType={auctionType}
              formData={formData}
              isErrOpeningPrice={isErrOpeningPrice}
              editRoleDetail={editRoleDetail}
              isSetState={data => {
                isSetState(data)
              }}
            />
            {/* bid submission */}
            <BidSubmission
              formData={formData}
              editRoleDetail={editRoleDetail}
              isErrBIDDecrement={isErrBIDDecrement}
              isErrBIDMinimum={isErrBIDMinimum}
              isErrBID={isErrBID}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>

          <Section className="form-col col-6">
            {/* Extension Time  */}
            <ExtensionTime
              formData={formData}
              editRoleDetail={editRoleDetail}
              isErrExtensionMinutes={isErrExtensionMinutes}
              isSetState={data => {
                isSetState(data)
              }}
            />
            {/* max extension  */}
            <MaxExtensionTime
              formData={formData}
              editRoleDetail={editRoleDetail}
              isErrMaxExtensionTime={isErrMaxExtensionTime}
              isSetState={data => {
                isSetState(data)
              }}
            />
            {/* Display Dummy  */}
            <DisplayDummy
              formData={formData}
              editRoleDetail={editRoleDetail}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>
        </Section>
      </>
    )
  }
}
